export function isReadOnlyAdminMode(): boolean {
  const value = String(import.meta.env.VITE_ADMIN_READ_ONLY ?? '').toLowerCase();
  return value === '1' || value === 'true' || value === 'yes';
}

export function adminReadOnlyLabel(): string {
  return 'READ ONLY';
}
